// Packages
import React from 'react'
import moment from 'moment'
import { Avatar, Row, Col, Tag } from 'antd'
// Images
import marsIcon from '../../public/img/gender_male.svg'
import venusIcon from '../../public/img/gender_female.svg'
import nationalityIcon from '../../public/img/nationality.svg'
import locationIcon from '../../public/img/location.svg'
import { Applicant } from './ProfileDownload'

const Gender = ({ gender }: { gender: 'Male' | 'Female' }) => {
	if (gender === 'Male') return <img src={marsIcon} alt="Mars Icon" />
	else if (gender === 'Female') return <img src={venusIcon} alt="Venus Icon" />
	else return null
}

const Nationality = ({ nationality }: { nationality: 'SG' | 'SP' | 'MY' }) => {
	switch (nationality) {
	case 'SG':
		return (
			<span style={{ display: 'inline-block' }}>
          &nbsp;&nbsp; | &nbsp;&nbsp;
				<img
					src={nationalityIcon}
					alt="nationalityIcon"
					style={{ width: '1rem' }}
				/>{' '}
          &nbsp;Singaporean&nbsp;
			</span>
		)
	case 'SP':
		return (
			<span>
          &nbsp;&nbsp; | &nbsp;&nbsp;
				<img
					src={nationalityIcon}
					alt="nationalityIcon"
					style={{ width: '1rem' }}
				/>
          &nbsp;Singapore PR&nbsp;
			</span>
		)
	case 'MY':
		return (
			<span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
				<img
					src={nationalityIcon}
					alt="nationalityIcon"
					style={{ width: '1rem' }}
				/>
          &nbsp;Malaysian&nbsp;
			</span>
		)
	default:
		return (
			<span>
          | &nbsp;&nbsp;
				<img
					src={nationalityIcon}
					alt="nationalityIcon"
					style={{ width: '1rem' }}
				/>
          &nbsp;{nationality} &nbsp;
			</span>
		)
	}
}

const Location = ({ locationOther }: { locationOther: string }) => {
	if (locationOther) {
		return (
			<span>
        &nbsp;&nbsp;|&nbsp;&nbsp;
				<img src={locationIcon} alt="locationIcon" style={{ width: '1rem' }} />
        &nbsp;{locationOther}&nbsp;&nbsp;
			</span>
		)
	} else {
		return null
	}
}

type Props = { applicant: Applicant };
const ProfileAvatar = ({ applicant }: Props) => {
	const {
		avatar,
		gender,
		name,
		age,
		nationality,
		locationOther,
		isStartWorkNow,
		dateOfBirth,
		Enum_WorkPass,
	} = applicant

	const getAge = () => {
		const dob = applicant.dateOfBirth
		if (dob !== null) {
			const age = moment().diff(moment(dob, 'YYYYMMDD'), 'years')
			return age
		} else return applicant.age
	}

	return (
		<Row gutter={[16, 16]}>
			<Col span={24}>
				{avatar && (
					<Col span={12} style={{ textAlign: 'left' }}>
						<Avatar src={avatar} alt="avatar" size={100} />
					</Col>
				)}
				<h2>{name}</h2>
				<div>
					<Row>
						<Col>
							<div style={{ marginTop: '10px' }}>
								{(age || dateOfBirth !== null) && `${getAge()} years old `}
                &nbsp;&nbsp; |{/* gender */}
								<Gender gender={gender} />
                &nbsp;&nbsp;
								{`${
									gender &&
                  gender.charAt(0).toUpperCase() +
                    gender.substring(1).toLowerCase()
								} `}
                &nbsp;
								{nationality && <Nationality nationality={nationality} />}
								{locationOther && <Location locationOther={locationOther} />}
								{Enum_WorkPass?.workPass && (
									<span>&nbsp; | &nbsp; {Enum_WorkPass?.display}</span>
								)}
							</div>
						</Col>
					</Row>
				</div>

				{isStartWorkNow ? (
					<div style={{ marginBottom: '10px', marginTop: '10px' }}>
						<Tag style={{ borderRadius: '10px' }} color="success">
              Start Work Immediately
						</Tag>
					</div>
				) : (
					''
				)}
			</Col>
		</Row>
	)
}

export default ProfileAvatar
